import { __assign } from "tslib";
import * as React from 'react';
function IconEyeCloseSizeM(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24" }, props),
        React.createElement("path", { clipRule: "evenodd", d: "M1 12c1.73-4.39 6-7.5 11-7.5 2.389 0 4.611.71 6.47 1.93l-2.514 2.513A4.993 4.993 0 0012 7c-2.76 0-5 2.24-5 5a4.99 4.99 0 001.943 3.956L6.67 18.23A11.886 11.886 0 011 12zm7.697 7.031c1.048.305 2.156.469 3.303.469 5 0 9.27-3.11 11-7.5a11.877 11.877 0 00-2.947-4.325l-3.184 3.184a5.002 5.002 0 01-6.01 6.01l-2.162 2.162zM9 12c0-1.66 1.34-3 3-3 .716 0 1.373.25 1.888.666l-4.214 4.232A2.99 2.99 0 019 12z" }),
        React.createElement("path", { d: "M4.901 19.998l-1.414-1.414L19.043 3.028l1.414 1.414z" })));
}
export default IconEyeCloseSizeM;
